// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"62a53048","309":"aaf69954","310":"b2c4c5a8","441":"7f9d533c","541":"93f628b7","690":"5fa860e0","956":"4d127f72"}[chunkId] + ".chunk.js";
};